module.exports = __webpack_public_path__ + "static/media/welcome-modal-nova.3aa8b5ae.jpg";